import { atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import { GiftCouponByCode, GiftCouponForPublic } from './giftCoupon.interface';

// 코드로 쿠폰 조회 (public)
export const giftCouponByCodeStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftCouponByCodeStatusAtomFamily',
  default: 'idle',
});

export const giftCouponByCodeDataAtomFamily = atomFamily<GiftCouponByCode | null, string>(
  {
    key: 'giftCouponByCodeDataAtomFamily',
    default: null,
  },
);

// ID로 쿠폰 조회 (public)
export const giftCouponByIdStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftCouponByIdStatusAtomFamily',
  default: 'idle',
});

export const giftCouponByIdDataAtomFamily = atomFamily<
  GiftCouponForPublic | null,
  string
>({
  key: 'giftCouponByIdDataAtomFamily',
  default: null,
});
